import { Stack } from "@mantine/core";
import React, { useCallback, useState } from "react";
import UA1 from "./UA1";
import UAFinish from "./UAFinish";

const AccountLocked = ({ setIsLocked }) => {
  const [activeStep, setActiveStep] = useState(0);
  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const stepContent = useCallback(() => {
    if (activeStep === 0) {
      return <UA1 handleNext={handleNext} />;
    }
    if (activeStep === 1) {
      return <UAFinish setIsLocked={setIsLocked} />;
    }
  }, [activeStep]);

  return (
    <Stack spacing={2} justifyContent="center" textAlign="center" p={"md"}>
      {stepContent()}
    </Stack>
  );
};

export default AccountLocked;
